import { modalKeys } from './constants'

import { createEventEmitter } from '../event'

export const modalEventEmitter = createEventEmitter()

export const emitModalStatus = status =>
    modalEventEmitter.emit(modalKeys.MODAL_STATUS, status)
